import { match } from '../utils';

const Platform = {
  os: '',
  name: 'Web',
};

const UA = window.navigator.userAgent || '';

function init(UA) {
  function setOS(result) {
    return function () {
      Platform.os = result;
    };
  }

  Platform.os = '';
  Platform.name = 'Web';

  match(UA, /iPhone|iPad|iPod/i, setOS('iOS'));
  match(UA, /Android/i, setOS('Android'));
  match(UA, /Mac OS X/i, setOS('Mac'));
  match(UA, /Windows/i, setOS('Windows'));

  if (Platform.os === '') {
    Platform.os = 'Unknow';
  }

  Platform.ua = UA;
}

init(UA);

Platform.update = init;

export default Platform;
